export default function () {
  return {
    andamento: {},
  };
}
